import React from 'react'
import '../../App.css'
import HeroSection from '../HeroSection'
import Cards from '../Cards';
import CardsCert from '../Certificados/CardsCert';
import Footer from '../../Footer/Footer';
import TimeLine from '../Timeline/TimeLine';
import Chrono from '../Chrono/chrono';


function Home () {
    return (
        <div>
            <HeroSection/>
            <Cards/>
            <CardsCert />
            <TimeLine />
            <Footer />
        </div>
    );
}

export default Home;